module.exports = __webpack_public_path__ + "img/sh.478d0d09.svg";